import { useSpring, animated } from '@react-spring/web';
import { useState } from 'react';
import { MdOutlineZoomOutMap } from 'react-icons/md';

const ReferenceImage = ({ src }) => {
    const [hovered, setHovered] = useState(false);
    const spring = useSpring({
        opacity: hovered ? 0.5 : 0
    })

    return (
        <div
            className="relative"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <a
                href={src}
                target="_blank"
                rel="noreferrer"
            >
                <img
                    src={src}
                    alt="reference billede"
                />
                <animated.div
                    className="absolute flex justify-center items-center top-0 left-0 bottom-0 right-0 bg-black"
                    style={spring}
                >
                    <MdOutlineZoomOutMap
                        size={35}
                    />
                </animated.div>
            </a>
        </div>
    )
}

export default ReferenceImage;